export default __webpack_public_path__ + "static/media/Zone-5-Master-Plan.0368333f.png";